import { useQuery } from '@tanstack/react-query';
import { getChartOfAccounts } from '../services/accountService';
import { getCurrentCompanyId } from '../utils/auth';

export const useAccounts = (companyId = null) => {
  const actualCompanyId = companyId || getCurrentCompanyId();
  
  return useQuery({
    queryKey: ['accounts', actualCompanyId],
    queryFn: () => getChartOfAccounts(actualCompanyId),
    enabled: !!actualCompanyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Helper function to flatten hierarchical accounts
export const flattenAccounts = (accounts) => {
  let result = [];
  accounts?.forEach(account => {
    result.push(account);
    if (account?.children && account.children.length > 0) {
      result = result.concat(flattenAccounts(account.children));
    }
  });
  return result;
};

// Helper function to filter accounts by type
export const filterAccountsByType = (accounts, types) => {
  const flattened = flattenAccounts(accounts);
  return flattened.filter(account => 
    types.includes(account.type) && account.isActive
  );
};
